// tslint:disable:only-arrow-functions
import { recommendationsPanelsLocaleKeys } from '@epicuro-next/constants/features/localization';
import { mergeMultipleConfigs } from '@epicuro-next/platform/dynamic-components-utils';
import { BoughtThisSeasonProviderConfigArgsProperties } from 'models-recommendation';

import { horizontalScrollablePanelBoughtThisSeason } from './horizontal-scrollable-panel-bought-this-season';

export const horizontalScrollablePanelReStock = mergeMultipleConfigs(
  horizontalScrollablePanelBoughtThisSeason[0],
  [
    {
      id: 'root',
      data: {
        headerText: recommendationsPanelsLocaleKeys.reStock,
        [BoughtThisSeasonProviderConfigArgsProperties.isDelivered]: true,
        [BoughtThisSeasonProviderConfigArgsProperties.isGlobalNoos]: true,
        [BoughtThisSeasonProviderConfigArgsProperties.searchSortType]: 'Stock',
        [BoughtThisSeasonProviderConfigArgsProperties.type]: 'now',
        [BoughtThisSeasonProviderConfigArgsProperties.fromDate]: 150,
        [BoughtThisSeasonProviderConfigArgsProperties.toDate]: 90,
        panelStyle: {
          values: [
            {
              provider: 'GlobalStoreProviderService',
              property: {
                paths: ['router.state.url'],
              },
            },
          ],
          transform: function ([routerUrl]: string[]) {
            if (
              routerUrl.includes('basket') &&
              !routerUrl.includes('basket-')
            ) {
              return 'SPCBRS';
            }
            return 'SPPBRS';
          }.toString(),
        },
      },
    },
  ],
);
